import { useEffect } from 'react';
import { money } from '../lib/format';

export const PALETTE = [
  '#224eae', // Brand Blue
  '#0f172a', // Black
  '#64748b', // Slate Gray
  '#1e3a8a', // Navy Blue
  '#475569', // Dark Gray
  '#3b82f6', // Light Brand Blue
  '#3b82f6'
];
export const colorAt = (i) => PALETTE[i % PALETTE.length];

export function Loader() {
  return <div className="center">Loading…</div>;
}

export function ErrorMsg({ error, onRetry }) {
  if (!error) return null;
  return (
    <div className="err">
      {error}
      {onRetry && (
        <> · <button className="linklike" onClick={onRetry} style={{ border: 0, background: 'none', color: 'inherit', textDecoration: 'underline' }}>retry</button></>
      )}
    </div>
  );
}

export function Empty({ children }) {
  return <div className="empty">{children}</div>;
}

export function Stat({ kind, label, value, currency }) {
  return (
    <div className={`stat ${kind || ''}`}>
      <div className="label">{label}</div>
      <div className="value">{typeof value === 'number' ? money(value, currency) : value}</div>
    </div>
  );
}

export function Toast({ message, onDone, ms = 1800 }) {
  useEffect(() => {
    if (!message) return undefined;
    const t = setTimeout(onDone, ms);
    return () => clearTimeout(t);
  }, [message, onDone, ms]);
  if (!message) return null;
  return <div className="toast">{message}</div>;
}
